import { createContext, useContext } from 'react';

/**
 * Lets a page ask the app shell to drop its surrounding chrome — footer,
 * mobile bottom nav, chat button — for as long as that page is mounted.
 *
 * App.js already hides those for /private via a pathname check. That trick
 * can't work for the 404 page: it's the catch-all route, so its pathname is
 * whatever the visitor typed. The page has to say so itself, and this is how.
 *
 * Contract: call setBare(true) on mount, setBare(false) on unmount.
 */
export const BareLayoutContext = createContext(() => {});

export const useBareLayout = () => useContext(BareLayoutContext);
